<style scoped>
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
</style>

<template>
  <v-row class="mt-5 mb-n8">
    <v-col cols="12" lg="3">
      <v-text-field
        v-model="search_text"
        prepend-inner-icon="mdi-magnify"
        label="ผู้ติดต่อ, เลขที่เอกสาร,ค้นหาจากชื่อ"
        outlined
        dense
      ></v-text-field>
    </v-col>
    <v-col cols="12" lg="4" class="mx-n3">
      <date-picker
        :format="momentFormat"
        v-model="time3"
        range
        class="custom-datepicker"
      ></date-picker>
    </v-col>
    <v-col cols="12" lg="2" class="ml-n8 mr-n5">
      <v-btn
        @click="search()"
        color="white excel-border"
        style="height: 40px"
        elevation="0"
        light
      >
        <v-icon left>mdi-magnify</v-icon>
        ค้นหา
      </v-btn>
    </v-col>
    <v-col cols="12" lg="2" class="ml-n15">
      <v-btn
        @click="clear()"
        color="white excel-border"
        style="height: 40px"
        elevation="0"
        light
      >
        <v-icon left>mdi-close</v-icon>
        ล้าง
      </v-btn>
    </v-col>
    <v-col cols="12" lg="1" class="ml-4 text-right">
      <v-btn @click="onExport" color="white excel-border" elevation="0" light>
        <v-icon left>mdi-printer</v-icon>ดาวน์โหลด excel
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import XLSX from "xlsx"; // import xlsx
import moment from "moment";
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "SearchBar",
  props: {
    Page: String
  },
  data: () => ({
    time3: [],
    search_text: "",
    momentFormat: {
      // Date to String
      stringify: (date) => {
        return date
          ? moment(date)
            .locale("th")
            .format("LL")
          : "";
      },
      // String to Date
      parse: (value) => {
        return value ? moment(value, "LL").toDate() : null;
      },
    },
    json: [],
  }),
  computed: {
    ...mapGetters({
      GET_SE_TEXT: "Drawer/GET_SE_TEXT",
      GET_SE_TIME: "Drawer/GET_SE_TIME"
    }),
    // time3: {
    //   get() {
    //     return this.GET_SE_TIME;
    //   },
    //   set(value) {
    //     this.SET_SE_TIME(value);
    //   },
    // },
    // search: {
    //   get() {
    //     return this.GET_SE_TEXT;
    //   },
    //   set(value) {
    //     this.SET_SE_TEXT(value);
    //   },
    // },
  },
  methods: {
    ...mapMutations({
      SET_SE_TEXT: "Drawer/SET_SE_TEXT",
      SET_SE_TIME: "Drawer/SET_SE_TIME"
    }),
    search() {
      let time = this.time3
      let se_text = this.search_text

      if (this.Page == 'Quotation') {
        this.$parent.list_quotation(time, se_text)
      } else if (this.Page == 'Bill') {
        this.$parent.list_bill(time, se_text)
      } else if (this.Page == 'Invoice') {
        this.$parent.list_invoices(time, se_text)
      }
    },
    clear() {
      this.time3 = []
      this.search_text = ""
      this.search()
    },
    onExport() {
      let time = this.time3
      let se_text = this.search_text
      if (this.Page == 'Quotation') {
        this.$parent.export_quotation(time, se_text)
      } else if (this.Page == 'Bill') {
        this.$parent.export_bill(time, se_text)
      } else if (this.Page == 'Invoice') {
        this.$parent.export_invoice(time, se_text)
      }


    },
  },
};
</script>
